import { useCallback, useEffect, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
import Areas from "./Areas";
import Treatments from "./Treatments";
import areaData from "./area_data";
import treatmentData from "./online_treatment_data.json";
import Loader from "./Loader";
import ErrorMessage from "./ErrorMessage";
// import { selectArea, setShowAllTreatments } from "./servicesList.actions";

export default function Services() {
  // const dispatch = useDispatch();
  const [host, setHost] = useState(window.location.host);
  const [initializing, setInitializing] = useState(true);
  const [areas, setAreas] = useState(areaData);
  const [treatments, setTreatments] = useState(treatmentData);
  const [availableTreatments, setAvailableTreatments] = useState(treatmentData);
  // const selectedArea = useSelector((state) => state.servicesList.selectedArea);
  const [selectedArea, setSelectedArea] = useState(null);
  // const showAllTreatments = useSelector((state) => state.servicesList.showAllTreatments);
  const [showAllTreatments, setShowAllTreatments] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);

  function smoothScroll(target) {
    const targetElement = document.querySelector(target);

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  }

  const getTreatments = useCallback((area, remove) => {
    console.log("getTreatments for:", !area ? "all" : area);
    if (!area) {
      setAvailableTreatments(treatmentData);
      return;
    }

    let filteredTreatments;
    if (remove) {
      filteredTreatments = treatmentData.filter((treatment) => treatment.areas.indexOf(area) === -1);
    } else {
      filteredTreatments = treatmentData.filter((treatment) => treatment.areas.indexOf(area) > -1);
    }
    console.log(filteredTreatments);
    setAvailableTreatments(filteredTreatments);
  }, []);

  // const selectArea = useCallback(
  //   (area) => {
  //     console.log("setSelectArea", area);
  //     getTreatments(area.slug);
  //   },
  //   [getTreatments]
  // );

  const setSelectArea = useCallback(
    (area) => {
      console.log("setSelectArea", area);
      // dispatch(setShowAllTreatments(false));
      setShowAllTreatments(false)
      setSelectedArea(area.slug)
      // dispatch(selectArea(area.slug));
      //setCurrentStep(1);
      getTreatments(area.slug);

      // smoothScroll("#treatments");
    },
    [getTreatments]
  );

  useEffect(() => {
    if (initializing) {
      let searchParams = new URLSearchParams(document.location.search), areaToSelect = null;
      if (searchParams.get("area") || searchParams.get("_areas")) {
        let searchArea = searchParams.get("area") || searchParams.get("_areas");
        areaToSelect = areas.filter((item, index) => {
          return item.slug === searchArea;
        });
        //dispatch(selectArea(areaToSelect[0]));
        setSelectArea(areaToSelect[0]);
        //smoothScroll("#servicesList");
      }
      if (window.location.hostname !== "localhost") {
        setHost(window.location.host);
      } 
      // else {
      //   //setHost("localhost:10010");
      //   setHost("attunemedspa.local");
      // }

      // const area = areaToSelect ? areaToSelect[0] : selectedArea;
      //getTreatments(area);
      setInitializing(false);
    }
  }, [host, initializing, areas, selectedArea, getTreatments, setSelectArea]);

  const handleBookNow = (treatment) => {
    window.location.href = "//" + host + "/book-now?serviceId=" + treatment.serviceId;
  };

  const goToAllTreatments = () => {
    console.log("goToAllTreatments");
    // dispatch(selectArea(null));
    setSelectedArea(null);
    // dispatch(setShowAllTreatments(true));
    setShowAllTreatments(true);

    getTreatments();
    smoothScroll("#areas");
  };

  return (
    <>
      <div className="pb-5">
        <div className="container-lg services-wrapper" id="servicesList">
          <div className="container position-relative services-container mx-auto">
            <div className="services-section" id="areas" data-title="Services">
              {areas && <Areas areas={areas} selectArea={setSelectArea} selectedArea={selectedArea} host={host} />}
            </div>
            <div className="row">
              <div className="col text-center">
                {!showAllTreatments && (<button type="button" className={`btn btn-outline-primary`} onClick={(e) => goToAllTreatments()}>
                  See All Treatments
                </button>)}
              </div>
            </div>
            <div className="services-section" id="treatments" data-title="Treatments">
              {treatments && (
                <Treatments treatments={availableTreatments} showTreatments={availableTreatments} handleBookNow={handleBookNow} host={host} />
              )}
            </div>
          </div>
        </div>
        {loading && <Loader />}
        {showError && <ErrorMessage />}
      </div>
    </>
  );
}
